import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import mundoLogo from './img/mundo-logo.png';
import sonyOneLogo from './img/Sonyone-303x70.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [rut, setRut] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    changeDefaultLocale('es');
    setShowForm(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username: rut,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage");

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="mundopacifico-wrapper" ref={nodeRef}>
        <div className="logos-container">
          <img src={mundoLogo} alt="Mundo Logo" className="mundo-logo" />
          <img src={sonyOneLogo} alt="Sony One Logo" className="sonyone-logo" />
        </div>

        <p className="subtitle">Mundo ¡Tecnología al alcance de todos!</p>

        <h1 className="title">
          <span className="title-primary">Ingresa con tus</span><br />
          <span className="title-orange">credenciales de Sucursal Virtual</span>
        </h1>

        <Form className="login-form" onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="mundopacifico-form-container">
            <Row className="mundopacifico-form-body">
              <Col sm="12" xs="12" md="12" className="mundopacifico-input">
                <label htmlFor="rut" className="input-label">RUT</label>
                <div className="input-container">
                  <i className="fa-regular fa-id-card left-icon"></i>
                  <Input
                    className="user-input-mundopacifico"
                    disabled={onLogin}
                    required={true}
                    tabIndex={1}
                    type="text"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="rut"
                    onChange={e => setRut(e.target.value)}
                    placeholder="12345678-9"
                  />
                </div>
                <span className="help-text">Solo numeros, sin puntos ni digito verificador</span>
              </Col>

              <Col sm="12" xs="12" md="12" className="mundopacifico-input">
                <label htmlFor="password" className="input-label">Contraseña</label>
                <div className="input-container">
                  <i className="fa-solid fa-lock left-icon" style={{ opacity: 0.5 }}></i>
                  <Input
                    className="pass-input-mundopacifico"
                    required={true}
                    disabled={onLogin}
                    tabIndex={1}
                    type={showPassword ? "text" : "password"}
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="password"
                    placeholder="Contraseña"
                    onChange={e => setPassword(e.target.value)}
                  />
                  <i
                    className={`fa-regular ${showPassword ? "fa-eye-slash" : "fa-eye"} toggle-password`}
                    onClick={() => setShowPassword(!showPassword)}
                  ></i>
                </div>
              </Col>

              <Col sm="12" xs="12" md="12" className="mundopacifico-input">
                {!onLogin ? (
                  <button
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-mundopacifico"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </Col>

              <Col sm="12" xs="12" md="12" className="mundopacifico-input">
                <a href="#" className="forgot-password">¿Olvidaste tu contraseña?</a>
              </Col>
            </Row>

            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ ...error, open: false })}
              >
                {error.message}
              </Alert>
            </div>

            <Row>
              <Col style={{ padding: '0' }}>
                <div className="captcha-container">
                  <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
                </div>
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true });
